const type = 'UPDATE_NEW_CARD_FORM';

const updateNewCardForm = (data) => ({
  data,
  type,
});

export default updateNewCardForm;
